import React from 'react';
import { GetStaticProps } from 'next';
import { ContentApi } from '@model/iceberg/service/content';
import { Revalidate } from '@model/config/revalidate';
import { Page, TripTypes } from '@model/common';
import { PageTemplates } from '@model/content';
import { storeWrapper } from '@state/store';
import { DestinationPageHolidaysLayout, DestinationPageHolidaysLayoutProps } from '@layout/DestinationPageLayout';
import { getStaticPropsDestinations } from '@layout/get-page-props';
import { withGlobalProvider } from 'providers/globalProvider';
import { DestinationLevel, getDestinationPagePaths } from '@util/get-destination-static-paths';

const DestinationRegionPageHolidays = (props: DestinationPageHolidaysLayoutProps) => {
  return <DestinationPageHolidaysLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ res, params }: any) => ({
  ...(await getStaticPropsDestinations({ store, res, query: params, tripType: TripTypes.HOLIDAYS })),
  revalidate: Revalidate.HALF_HOUR
}));

export async function getStaticPaths() {
  const destinationPages = await new ContentApi().getPageConfigMap({ template: PageTemplates.DESTINATION });
  const paths = getDestinationPagePaths({
    destinationPages,
    level: DestinationLevel.REGION,
    tripType: TripTypes.HOLIDAYS,
    suffix: Page.HOLIDAYS
  });

  return { paths, fallback: false };
}

export default withGlobalProvider(DestinationRegionPageHolidays);
